import type { ThemeVariant } from './ThemeVariant'
import isStorageThemeVariantKey from './isStorageThemeVariantKey'

export default function getSafeThemeVariant(key: string): ThemeVariant {
  if (!isStorageThemeVariantKey(key)) {
    return 'default'
  }

  return key
}
